import { PERMISSION, ROLE } from '@maxpreps/shared/constants/authentication';
import {
  useIsSignedIn,
  useUserFavoriteCareers,
  useUserFavoriteTeams,
  useUserRoles
} from '@maxpreps/shared/redux/user/userHooks';
import dynamic from 'next/dynamic';
import FollowingBox from './FollowingBox';
import AdminList from './lists/AdminList';
import FavoritesList from './lists/FavoritesList';
import UserBox from './UserBox';

const filterTeams = (roles, favoriteTeams) =>
  Array.isArray(favoriteTeams)
    ? favoriteTeams.filter(
        f =>
          !roles.some(
            r => r.accessId1 === f.schoolId && r.accessId2 === f.allSeasonId
          )
      )
    : [];

const filterCareers = (roles, favoriteCareers) =>
  Array.isArray(favoriteCareers)
    ? favoriteCareers.filter(
        f =>
          !roles.some(
            r =>
              r.accessId1 === f.careerProfileId &&
              r.permissions.some(
                p =>
                  p.permissionId === PERMISSION.careerAthlete ||
                  p.permissionId === PERMISSION.careerParent
              )
          )
      )
    : [];

const UserMenu: React.FC = () => {
  const isSignedIn = useIsSignedIn();
  const favoriteCareers = useUserFavoriteCareers();
  const favoriteTeams = useUserFavoriteTeams();
  const roles = useUserRoles();

  if (!isSignedIn) return null;

  const filteredTeams = filterTeams(roles, favoriteTeams);
  const filteredCareers = filterCareers(roles, favoriteCareers);

  // the career role doesn't have all the data we need it to have so we are going to map it on from the career favorite
  // theres 100% a chance the role and fav arent' one-to-one. If that becomes a noticable problem
  // then the page data api needs updated to have the additional career info.
  const mappedRoles = roles?.map(r => {
    const copyOfRole = { ...r };

    if (copyOfRole.roleId === ROLE.career) {
      var favoriteCareer = favoriteCareers?.find(
        f => f.careerProfileId === copyOfRole.accessId1
      );

      if (favoriteCareer) {
        copyOfRole.header = favoriteCareer.header;
        copyOfRole.subHeader = favoriteCareer.subHeader;
        copyOfRole.photoUrl = favoriteCareer.photoUrl;
        copyOfRole.schoolColor1 = favoriteCareer.schoolColor1;
        copyOfRole.schoolColor2 = favoriteCareer.schoolColor2;
        copyOfRole.schoolColor3 = favoriteCareer.schoolColor3;
        copyOfRole.link = favoriteCareer.link;
      }
    }

    return copyOfRole;
  });

  return (
    <>
      <UserBox />
      <AdminList roles={mappedRoles} />
      <FollowingBox />
      <FavoritesList teams={filteredTeams} careers={filteredCareers} />
    </>
  );
};

export default dynamic(() => Promise.resolve(UserMenu), { ssr: false });
